<template>
  <div class="extension__index">
    <index-header :title="title" :createName="createName" :entity="entity"></index-header>

    <datagrid :entries="entries" :entity="entity" :filter-cols="filterCols" :create-name-override="createName" :edit-name-override="editName" :collectionMax="collectionMax" :perPage="perPage" :collection="collection" @paginated="paginated"></datagrid>
  </div>
</template>


<script>
import Datagrid from '@/components/Datagrid';
import IndexHeader from '@/components/IndexHeader';

export default {
  name: 'ExtensionIndex',
  props: [
    'entries',
    'entity',
    'title',
    'createName',
    'filterCols',
    'editName',
    'collectionMax',
    'perPage',
    'collection',
    'currentPage',
  ],
  components: {
    Datagrid,
    IndexHeader,
  },
  methods: {
    paginated(value) {
      this.$emit('paginated', value);
    },
  },
};
</script>
